import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SunGlasses from "./pages/SunGlasses";
import Contact from "./pages/Contact";
import SpecialPowerPage from "./pages/SpecialPowerPage";
import StoresPage from "./pages/StoresPage";
import TryAtHomePage from "./pages/TryAtHomePage";
import ContactsPage from "./pages/ContactsPage";
import About from "./pages/About";
import BuyingGuide from "./pages/BuyingGuide";
import FrameSize from "./pages/FrameSize";
import FAQ from "./pages/FAQ";
import TrackOrder from "./pages/TrackOrder";      // keep this one
import Returns from "./pages/Returns";
import Eyeglasses from "./pages/Eyeglasses";
import ReferEarn from "./pages/ReferEarn";      
import Grievance from "./pages/Grievance";  
import SignInSignUp from "./pages/SignInSignUp";
import LocateStorePage from "./pages/LocateStorePage";    
import FloatingContact from './components/FloatingContact';

// Layout component remains the same
const Layout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white">
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/products" element={<Layout><SunGlasses /></Layout>} />
          <Route path="/special-power" element={<Layout><SpecialPowerPage /></Layout>} />
          <Route path="/stores" element={<Layout><StoresPage /></Layout>} />
          <Route path="/try-at-home" element={<Layout><TryAtHomePage /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/contact-us" element={<Layout><ContactsPage /></Layout>} />
          <Route path="/eyeglasses" element={<Layout><Eyeglasses /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/buying-guide" element={<Layout><BuyingGuide /></Layout>} />
          <Route path="/frame-size" element={<Layout><FrameSize /></Layout>} />
          <Route path="/faq" element={<Layout><FAQ /></Layout>} />
          <Route path="/track-order" element={<Layout><TrackOrder /></Layout>} />   {/* single route */}
          <Route path="/returns" element={<Layout><Returns /></Layout>} />
          <Route path="/referearn" element={<Layout><ReferEarn /></Layout>} />
          <Route path="/grievance" element={<Layout><Grievance /></Layout>} />
          <Route path="/signin" element={<Layout><SignInSignUp /></Layout>} />
          <Route path="/locate-store" element={<Layout><LocateStorePage /></Layout>} />
          {/* Removed /top-categories route */}
        </Routes>
        <FloatingContact />
      </div>
    </Router>
  );
}

export default App;